import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { withTranslation } from "react-i18next"

// Conmutador Lista / Kanban para las vistas de validación de servicios (SV2).
// `active` = "list" | "kanban". Navega a la ruta correspondiente en 1 clic,
// PRESERVANDO la query string actual para que los filtros aplicados (empresa,
// código, placa, plaza, validación, salud de ruta, rango de fecha) se compartan
// entre ambas vistas. El indicador (thumb) con gradiente se desliza bajo la
// opción activa.
const ServiceValidationViewToggle = ({ t, active }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const search = location.search || ""
  const isList = active === "list"

  return (
    <div className={`sv-view-toggle ${isList ? "is-list" : "is-kanban"}`} role="tablist">
      <span className="sv-view-toggle-thumb" aria-hidden="true" />
      <button
        type="button"
        role="tab"
        aria-selected={isList}
        className={`sv-view-toggle-btn ${isList ? "active" : ""}`}
        onClick={() => navigate(`/service-validation${search}`)}
      >
        <i className="bx bx-list-ul me-1" />
        {t("ListView")}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!isList}
        className={`sv-view-toggle-btn ${!isList ? "active" : ""}`}
        onClick={() => navigate(`/service-validation/kanban${search}`)}
      >
        <i className="bx bx-grid-alt me-1" />
        Kanban
      </button>
    </div>
  )
}

export default withTranslation()(ServiceValidationViewToggle)
